<div id="fullscreenElement" class="{{customClass}}" #fullscreenElement
  style="background-color: #FCF5F9;overflow-y: auto;">
  <!-- <input type="text">
  <button type="button" (click)="toggleFullscreen()">Lock Screen</button> -->
  <ng-content #content></ng-content>

</div>